
        //===== FILE GENERATED FROM BUILD PROCESS - OVERRIDDEN TO EACH BUILD ======//
        // Source code at: ./webpack/write-build-args.js
        
        export const BuildArgs = {
            platform: "web",
            profileName: "etm-newkb",
            profileEnvironment: "prod"
        }
        
        import * as EnvProps from "@kta20-webapp/profiles/etm-newkb/etm-newkb.prod.json"; export {EnvProps};
        import {default as profileBuilder} from "@kta20-webapp/profiles/etm-newkb/etm-newkb.prod.ts"; export {profileBuilder}
        export {AppContext} from "@kta20-core/app-context.web.ts";
        import "@kta20-webapp/profiles/etm-newkb/etm-newkb.css";
        
        //==========================================================================//
    